/**
 * 判断是否为移动端
 * @returns 是否为移动端
 */
const isMobile = () => /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);

/**
 * 判断是否为微信
 * @returns 是否为微信
 */
const isWeChat = () => /micromessenger/i.test(navigator.userAgent);

/**
 * 判断是否为企业微信
 * @returns 是否为企业微信
 */
const isWxWork = () => /wxwork/i.test(navigator.userAgent);

/**
 * 判断是否为PC端企业微信
 * @returns 是否为PC端企业微信
 */
const isPCWxWork = () => isWxWork() && !isMobile();

const isIE = () => !!window.ActiveXObject || "ActiveXObject" in window;

const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

export default {
    isMobile,
    isWeChat,
    isWxWork,
    isPCWxWork,
    isIE,
    isSafari,
}